import { render, staticRenderFns } from "./highlightText.vue?vue&type=template&id=e4ea7bd2&scoped=true"
import script from "./highlightText.vue?vue&type=script&lang=js"
export * from "./highlightText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ea7bd2",
  null
  
)

export default component.exports